/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
  if ($(window).width() > 800) {
    var sr = ScrollReveal();

    sr.reveal('.comparison-table__title', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal('.comparison-table__tabs', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal('.comparison-table__panel.is-active', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  function initComparisonTable($section) {
    var $tabs = $section.find('.comparison-table__tab');
    var $panels = $section.find('.comparison-table__panel');

    $panels.not('.is-active').hide();

    $tabs.on('click', function () {
      var target = $(this).data('tab');

      $tabs.removeClass('is-active');
      $(this).addClass('is-active');

      $panels.removeClass('is-active').hide();
      $section
        .find('.comparison-table__panel[data-panel="' + target + '"]')
        .addClass('is-active')
        .show();
    });
  }

  $('.comparison-table').each(function () {
    initComparisonTable($(this));
  });

  document.querySelectorAll('.comparison-table__tooltip-btn').forEach(function (btn) {
    var tooltip = btn.querySelector('.comparison-table__tooltip');
    if (!tooltip) return;

   btn.addEventListener('mouseenter', function () {
  tooltip.style.transition = 'none';
  tooltip.style.opacity = '0';
  tooltip.style.left = '50%';
  tooltip.style.transform = 'translateX(-50%) translateY(0)';
  tooltip.style.visibility = 'visible';

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      var rect = tooltip.getBoundingClientRect();
      var padding = 8;

      if (rect.right > window.innerWidth - padding) {
        var overflow = rect.right - (window.innerWidth - padding);
        tooltip.style.left = 'calc(50% - ' + overflow + 'px)';
      } else if (rect.left < padding) {
        var overflow2 = padding - rect.left;
        tooltip.style.left = 'calc(50% + ' + overflow2 + 'px)';
      }

      tooltip.style.transition = '';
      tooltip.style.opacity = '1';
    });
  });
});

btn.addEventListener('mouseleave', function () {
  tooltip.style.transition = 'none';
  tooltip.style.opacity = '0';
  tooltip.style.visibility = '';
  
  setTimeout(function () {
    tooltip.style.left = '';
    tooltip.style.transform = '';
    tooltip.style.transition = '';
  }, 0);
});


    
  });
});